module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "min-width": "1280px"
    }
  }, [_c('div', {
    staticClass: "jczl_div"
  }, [_c('span', {
    staticClass: "jczl_span1"
  }, [_vm._v("\n        分析统计\n      ")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "jczl_span2"
  }, [_vm._v("\n        共拥有 " + _vm._s(_vm.proNum) + " 个产品，闲置产品 " + _vm._s(_vm.proXZ) + " 个，已过期 " + _vm._s(_vm.proGQ) + " 个。\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "export"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": _vm.href
    }
  }, [_c('span', {
    staticClass: "el-icon-download"
  }), _vm._v("导出统计数据")])])])]), _vm._v(" "), _c('div', {}, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple icon_div"
  }, [_c('img', {
    staticClass: "x_icon",
    attrs: {
      "src": require("../../img/ZS.png")
    }
  }), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "span_size"
  }, [_vm._v("产品总数")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "div_span zs"
  }, [_vm._v(_vm._s(_vm.proNum))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple icon_div"
  }, [_c('img', {
    staticClass: "x_icon",
    attrs: {
      "src": require("../../img/XZ.png")
    }
  }), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "span_size"
  }, [_vm._v("闲置产品")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "div_span xz"
  }, [_vm._v(_vm._s(_vm.proXZ))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple icon_div"
  }, [_c('img', {
    staticClass: "x_icon",
    attrs: {
      "src": require("../../img/GQ.png")
    }
  }), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "span_size"
  }, [_vm._v("已过期产品")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "div_span ygq"
  }, [_vm._v(_vm._s(_vm.proGQ))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple icon_div"
  }, [_c('img', {
    staticClass: "x_icon",
    attrs: {
      "src": require("../../img/JGQ.png")
    }
  }), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "span_size"
  }, [_vm._v("即将过期")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "div_span jgq"
  }, [_vm._v(_vm._s(_vm.proJGQ))])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple icon_div2"
  }, [_c('div', {
    staticStyle: {
      "height": "65px"
    }
  }, [_c('span', {
    staticClass: "cptj_span"
  }, [_vm._v("积分统计")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative",
      "float": "right",
      "right": "10px",
      "top": "18px"
    }
  }, [_c('el-select', {
    staticClass: "checkName",
    on: {
      "change": _vm.changeTime
    },
    model: {
      value: (_vm.staTime),
      callback: function($$v) {
        _vm.staTime = $$v
      },
      expression: "staTime"
    }
  }, _vm._l((_vm.times), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "360px"
    },
    attrs: {
      "id": "echartZXT"
    }
  })])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple icon_div2"
  }, [_c('div', {
    staticStyle: {
      "height": "65px"
    }
  }, [_c('span', {
    staticClass: "cptj_span"
  }, [_vm._v("积分排行榜")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative",
      "float": "right",
      "right": "10px",
      "top": "18px"
    }
  }, [_c('el-button', {
    staticClass: "jf_button",
    staticStyle: {
      "position": "relative",
      "left": "15px"
    },
    on: {
      "click": function($event) {
        _vm.ranking(1)
      }
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('el-button', {
    staticClass: "jf_button",
    on: {
      "click": function($event) {
        _vm.ranking(2)
      }
    }
  }, [_vm._v("近30天")])], 1)]), _vm._v(" "), (_vm.masg2) ? _c('div', [_vm._l((_vm.values), function(val, index) {
    return _c('el-row', {
      key: index,
      staticStyle: {
        "width": "100%",
        "min-width": "560px"
      }
    }, [_c('div', {
      staticStyle: {
        "padding": "20px 0"
      }
    }, [(!val.photo) ? _c('img', {
      staticClass: "rank_left rank_img",
      attrs: {
        "src": require("../../img/person.png")
      }
    }) : _c('img', {
      staticClass: "rank_left rank_img",
      attrs: {
        "src": val.photo
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "rank_left rank_name"
    }, [_vm._v(_vm._s(val.name) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "rank_left rank_sump"
    }, [_vm._v(_vm._s(val.sumpoint) + " ")]), _vm._v(" "), _c('el-progress', {
      staticClass: "rank_num rank_left",
      attrs: {
        "text-inside": true,
        "percentage": val.num,
        "show-text": false,
        "stroke-width": 15,
        "color": _vm.customColor
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "rank_right rank_jfDiv"
    }, [_c('span', {
      staticClass: "but_span",
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          _vm.handleLine(val.userid, val.name)
        }
      }
    }, [_vm._v("积分统计")])]), _vm._v(" "), _c('img', {
      staticClass: "rank_right rank_lineImg rank_tjImg",
      attrs: {
        "src": require("../../img/line.png")
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "rank_right rank_mkDiv"
    }, [_c('span', {
      staticClass: "but_span",
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          _vm.handlePie(val.userid, val.name)
        }
      }
    }, [_vm._v("模块使用情况")])]), _vm._v(" "), _c('img', {
      staticClass: "rank_right rank_pieImg rank_tjImg",
      attrs: {
        "src": require("../../img/pie.png")
      }
    })], 1)])
  }), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-top": "0",
      "position": "relative",
      "top": "10px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.pageNumber,
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 2) : _c('div', {
    staticStyle: {
      "text-align": "center",
      "line-height": "19"
    }
  }, [_vm._v("无数据。。。")])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple icon_div2"
  }, [_c('div', {
    staticStyle: {
      "height": "65px"
    }
  }, [_c('span', {
    staticClass: "cptj_span"
  }, [_vm._v("产品统计")])]), _vm._v(" "), _c('div', {
    staticClass: "div_div"
  }), _vm._v(" "), _c('div', {
    staticClass: "cptj_div"
  }, _vm._l((_vm.products), function(product) {
    return _c('div', {
      staticStyle: {
        "padding": "20px 50px"
      }
    }, [_c('img', {
      staticClass: "cptj_img",
      attrs: {
        "src": product.logo
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cptj_name",
      attrs: {
        "title": product.name
      }
    }, [_vm._v(_vm._s(product.name))]), _vm._v(" "), _c('span', {
      staticClass: "cptj_num"
    }, [_c('B', [_vm._v(_vm._s(product.num))])], 1), _vm._v(" "), _c('div', {
      staticClass: "cptj_bottom"
    })])
  }), 0)])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple icon_div2"
  }, [_c('div', {
    staticStyle: {
      "height": "65px"
    }
  }, [_c('span', {
    staticClass: "cptj_span"
  }, [_vm._v("模块使用情况")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative",
      "float": "right",
      "right": "10px",
      "top": "18px"
    }
  }, [_c('el-select', {
    staticClass: "checkName",
    on: {
      "change": _vm.changeTime
    },
    model: {
      value: (_vm.staTime),
      callback: function($$v) {
        _vm.staTime = $$v
      },
      expression: "staTime"
    }
  }, _vm._l((_vm.times), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.masg),
      expression: "!masg"
    }],
    staticStyle: {
      "height": "360px"
    },
    attrs: {
      "id": "echartBT"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.masg),
      expression: "masg"
    }],
    staticStyle: {
      "height": "360px",
      "text-align": "center",
      "line-height": "20"
    }
  }, [_vm._v(" 无数据。。。")])])])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "model-edit",
    attrs: {
      "title": "选择人员",
      "visible": _vm.personVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.personVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px",
      "border": "1px solid #dfe6ec"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.souchs
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.changeSouch
    },
    model: {
      value: (_vm.souch_value),
      callback: function($$v) {
        _vm.souch_value = $$v
      },
      expression: "souch_value"
    }
  }, _vm._l((_vm.optionsSouch), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.getUser(1)
      }
    },
    model: {
      value: (_vm.proName),
      callback: function($$v) {
        _vm.proName = $$v
      },
      expression: "proName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.getUser(1)
      }
    }
  }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _vm._l((_vm.dynamicTags), function(tag) {
    return _c('el-tag', {
      key: tag,
      attrs: {
        "closable": "",
        "disable-transitions": false
      },
      on: {
        "close": function($event) {
          _vm.handleClose(tag)
        }
      }
    }, [_vm._v(" \n          " + _vm._s(tag) + " \n      ")])
  }), _vm._v(" "), (_vm.dynamicTags != '') ? _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.delTags
    }
  }, [_vm._v("清除标签")]) : _vm._e()], 2), _vm._v(" "), _c('el-table', {
    ref: "users",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.users,
      "highlight-current-row": "",
      "header-cell-style": _vm.getRowClass
    },
    on: {
      "current-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.checked),
            expression: "scope.row.checked"
          }],
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "checked": Array.isArray(scope.row.checked) ? _vm._i(scope.row.checked, null) > -1 : (scope.row.checked)
          },
          on: {
            "change": [function($event) {
              var $$a = scope.row.checked,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.$set(scope.row, "checked", $$a.concat([$$v])))
                } else {
                  $$i > -1 && (_vm.$set(scope.row, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
                }
              } else {
                _vm.$set(scope.row, "checked", $$c)
              }
            }, _vm.changeFun]
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "账号",
      "min-width": "130",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "min-width": "100",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "point",
      "label": "积分",
      "min-width": "120",
      "show-overflow-tooltip": ""
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "border": "1px solid #dfe6ec",
      "margin-top": "0"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": " prev, pager, next",
      "current-page": _vm.pageNumber2,
      "page-size": _vm.pageSize2,
      "total": _vm.total2
    },
    on: {
      "current-change": _vm.handleCurrentChange2
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.personVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.userSubmit($event)
      }
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "model-edit",
    attrs: {
      "title": "近30天模块使用",
      "visible": _vm.pieVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.pieVisible = $event
      }
    }
  }, [_c('span', {
    staticStyle: {
      "position": "absolute",
      "left": "30px",
      "top": "60px"
    }
  }, [_vm._v("当前人员 : " + _vm._s(_vm.pieName))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "360px"
    },
    attrs: {
      "id": "echartBT2"
    }
  })]), _vm._v(" "), _c('el-dialog', {
    staticClass: "model-edit",
    attrs: {
      "title": "近30天积分统计",
      "visible": _vm.lineVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.lineVisible = $event
      }
    }
  }, [_c('span', {
    staticStyle: {
      "position": "absolute",
      "left": "30px",
      "top": "60px"
    }
  }, [_vm._v("当前人员 : " + _vm._s(_vm.lineName))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "360px"
    },
    attrs: {
      "id": "echartZXT2"
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-453a0c91"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/individual/companys/Statistics.vue
// module id = 1121
// module chunks = 1